// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
 apiKey: "AIzaSyAKQVDRTt5i5i0cNyrSxxW_N-S1vpwm4Ec",
  authDomain: "valsco-jurident.firebaseapp.com",
  projectId: "valsco-jurident",
  storageBucket: "valsco-jurident.firebasestorage.app",
  messagingSenderId: "596718606544",
  appId: "1:596718606544:web:4dc72fd5ccab6b72bd66d5",
  measurementId: "G-CVM890582X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app)
export const db = getFirestore(app)
export const googleProvider = new GoogleAuthProvider()

// Initialize Messaging only if browser supports it
let messaging = null;
const initializeMessaging = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.log("Firebase Messaging is not supported in this browser");
    }
  } catch (error) {
    console.log("Error initializing Firebase Messaging:", error.message);
  }
  return messaging;
};

// Initialize messaging immediately
initializeMessaging();

googleProvider.addScope('https://www.googleapis.com/auth/calendar.readonly');
const storage = getStorage(app); // Initialize storage

// Export a function to get messaging instance (for use in other files)
export const getMessagingInstance = async () => {
  if (messaging) return messaging;
  return await initializeMessaging();
};

export { messaging, storage, app };